define('../app/fukit/behavior/set.model.attributes.on.event.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var SetModelAttributesOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      attributes: null,
      eventName: 'press',
      eventSource: null,
      model: null,
    },

    initialize: function() {
      var eventSource = this.getOption('eventSource') || this.view;
      this.listenTo(eventSource, this.getOption('eventName'), this.onEvent);
    },

    onEvent: function() {
      this.setModelAttributes();
    },

    setModelAttributes: function() {
      //prettier-ignore
      var attributes = Mn._getValue(this.getOption('attributes'), this),
          model = this.getOption('model') || this.view.model;

      if (!model) {
        return;
      }

      model.set(attributes);
    },
  });

  module.exports = SetModelAttributesOnEventBehavior;
});

